import Flex from './flex';

export * from './flex';

export default Flex;
